(function () {
  document.querySelectorAll('.tm-compare').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-compare-tab-btn]');

    function markLastVisibleRow() {
      var rows = section.querySelectorAll('.tm-compare-table tbody tr');
      rows.forEach(function (r) { r.classList.remove('tm-compare-row-last'); });
      var visible = Array.prototype.filter.call(rows, function (r) {
        return getComputedStyle(r).display !== 'none';
      });
      if (visible.length) visible[visible.length - 1].classList.add('tm-compare-row-last');
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-compare-tab-btn');
        section.setAttribute('data-compare-active', tab);
        tabs.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        markLastVisibleRow();
      });
    });

    markLastVisibleRow();
  });
})();
